import React from 'react';
import { IconDeviceDesktopFill } from '@saucelabs/ds-icons';

import Styles from './DevToolsDisabled.styles';

const DevToolsDisabled = () => (
  <div
    className={Styles['text-wrapper']}
    data-qa="developer-drawer-devtools-not-supported"
  >
    <IconDeviceDesktopFill className={Styles['desktop-icon']} />
    <p className={Styles['text-bold']}>
      DevTools is available on Chrome browser.
    </p>
    <p className={Styles['text-light']}>
      To use DevTools, sign into Sauce Labs using a Chrome browser,
      then choose a real iOS or Android device to begin your cross browser test session.
    </p>
  </div>
);

export default DevToolsDisabled;
